import {
  FETCH_STATE_OF_CHARGE_REQUEST,
  FETCH_STATE_OF_CHARGE_SUCCESS,
  FETCH_STATE_OF_CHARGE_FAILURE,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const stateOfChargeReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_STATE_OF_CHARGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_STATE_OF_CHARGE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_STATE_OF_CHARGE_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default stateOfChargeReducer;
